<template>
    <div>
        <ejs-grid
                ref="customCounterGrid"
                :dataSource="dataSourceOfCustomCounter"
                class="h100-60 h-scroll"
                :allowPaging="false"
                height='calc(100vh - 280px)'
                :rowSelected="rowSelectOfCustomCounter"
                :rowDeselected="rowDeselectOfCustomCounter">
            <e-columns>
                <e-column field="counterCode" :headerText='$t("Pm.counterCode")' textAlign="center"  width="9%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="counterNameCH" :headerText='$t("Pm.counterNameCH")' textAlign="center"  width="13%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="counterNameEN" :headerText='$t("Pm.counterNameEN")' textAlign="center"  width="13%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="counterFormula" :headerText='$t("Pm.counterFormula")' textAlign="center"  width="10%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="paramTypeName" :headerText='$t("Pm.counterParamType")' textAlign="center"  width="10%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="spaceName" :headerText='$t("Pm.counterSpace")' textAlign="center"  width="10%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="counterCreateTime" :headerText='$t("Pm.counterCreateTime")' textAlign="center"  width="11%"  clipMode="EllipsisWithTooltip" :formatter="dataFormatterFromTimeStramp"></e-column>
                <e-column field="counterUpdateTime" :headerText='$t("Pm.counterUpdateTime")' textAlign="center"  width="11%"  clipMode="EllipsisWithTooltip" :formatter="dataFormatterFromTimeStramp"></e-column>
                <e-column field="counterCreatePeople" :headerText='$t("Pm.counterCreatePeople")' textAlign="center"  width="7%"  clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="unit" :headerText='$t("Pm.counterUnit")' textAlign="center"  width="6%"  clipMode="EllipsisWithTooltip"></e-column>
            </e-columns>
        </ejs-grid>
        <ejs-pager ref='customCounterPager' @click='getCustomCounterList()' :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>
    </div>
</template>

<script>

    import DateUtil from "../../../util/DateUtil";

    export default {
        name: 'CustomCounterList',

        components: {
        },

        props: [
            'gnbCounterTreeClickInfo'
        ],

        data() {
            return {
                dataSourceOfCustomCounter: [],
                pageSettings: {
                    currentPage: 1,
                    pageSize: 18,
                    totalRecordsCount: 0,
                    pageCount: 10
                },
                spaceCode: null,
                paramTypeCode: null,
                counterSearchName: null,
                rowDataOfCustomCounter: ''
            };
        },

        methods: {

            dataFormatterFromTimeStramp(column,data){
                if(data[column.field] == null){
                    return null;
                } else {
                    const date = new Date(data[column.field]);
                    return DateUtil.getDateString(date);
                }
            },

            getCustomCounterList(){
                const language = localStorage.getItem('locale');
                this.pageSettings.currentPage = this.$refs.customCounterPager.ej2Instances.currentPage;
                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/getCustomCounterList.html', {
                    paramTypeCode: this.paramTypeCode,
                    spaceCode: this.spaceCode,
                    counterNameCH: language == 'zh' ? this.counterName : null,
                    counterNameEN: language == 'zh' ? null : this.counterName,
                    page: {
                        pageNo: this.pageSettings.currentPage,
                        pageSize: this.pageSettings.pageSize
                    }
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.pageSettings.totalRecordsCount = result.totalCount;
                    this.pageSettings.currentPage = result.pageNo;
                    this.dataSourceOfCustomCounter = result.result;
                    this.$loading.hideLoadding();
                });
            },

            rowSelectOfCustomCounter(msg){
                this.rowDataOfCustomCounter = msg.data;
            },

            rowDeselectOfCustomCounter() {
                this.rowDataOfCustomCounter = '';
            }
        },

        watch: {
            gnbCounterTreeClickInfo(treeClickInfo){
                this.pageSettings.currentPage = 1;
                this.$refs.customCounterPager.ej2Instances.currentPage = 1;
                const clickId = treeClickInfo.id;
                if(clickId == 'root'){
                    this.spaceCode = null;
                    this.paramTypeCode =null;
                }  else if(clickId.split('_')[1] == undefined) {
                    this.spaceCode = null;
                    this.paramTypeCode = clickId.split('_')[0]
                } else {
                    this.spaceCode = clickId.split('_')[0];
                    this.paramTypeCode = clickId.split('_')[1]
                }
                this.getCustomCounterList();
            }
        },

        mounted() {
            this.getCustomCounterList();
        }
    };
</script>

<style scoped>
</style>
